<!-- HTML -->
<template>
  <div>

    <img
      id="logo"
      v-bind:src="logo[position]"
      alt="Jugem's Cloud Logo"
    />

  </div>
</template>

<!-- JavaScript -->
<script>

export default {

  name: "NavMenuLogo",

  data() {

    return {

      position: 0,
      timeBeforeGlitch: 0,
      lengthOfGlitch: 0,
      glitchMachine: null,

      logo: {

        0: require('../../assets/img/logo/logo-720x240.png'),
        1: require('../../assets/img/logo/glitch/1.gif'),
        2: require('../../assets/img/logo/glitch/2.gif'),
        3: require('../../assets/img/logo/glitch/3.gif'),
        4: require('../../assets/img/logo/glitch/4.gif'),
        5: require('../../assets/img/logo/glitch/5.gif'),
        6: require('../../assets/img/logo/glitch/6.gif'),
        7: require('../../assets/img/logo/glitch/7.gif'),
        8: require('../../assets/img/logo/glitch/8.gif'),
        9: require('../../assets/img/logo/glitch/9.gif'),
        10: require('../../assets/img/logo/glitch/10.gif'),
        11: require('../../assets/img/logo/glitch/11.gif'),
        12: require('../../assets/img/logo/glitch/12.gif'),
        13: require('../../assets/img/logo/glitch/13.gif'),
        14: require('../../assets/img/logo/glitch/14.gif'),
        15: require('../../assets/img/logo/glitch/15.gif'),
        16: require('../../assets/img/logo/glitch/16.gif'),
        17: require('../../assets/img/logo/glitch/17.gif'),
        18: require('../../assets/img/logo/glitch/18.gif'),
        19: require('../../assets/img/logo/glitch/19.gif'),
        20: require('../../assets/img/logo/glitch/20.gif'),
        21: require('../../assets/img/logo/glitch/21.gif'),
        22: require('../../assets/img/logo/glitch/22.gif'),
        23: require('../../assets/img/logo/glitch/23.gif'),
        24: require('../../assets/img/logo/glitch/24.gif')

      }

    }

  },

  methods: {

    //--- Function initializeGlitchTimeout ---//
    initializeGlitchTimeout ( ) {

      this.timeBeforeGlitch = Math.random() * 3000; // 3 seconds max before glitch
      this.lengthOfGlitch = Math.random() * 1000; // 1 second max glitch

      // Run glitchTheLogo
      setTimeout( this.glitchTheLogo, this.timeBeforeGlitch );

    },

    //--- Function glitchTheLogo ---//
    glitchTheLogo ( ) {

      // Change the logo src every 1/24th of a second
      this.glitchMachine = setInterval ( () => {
        this.position = Math.floor(Math.random() * Math.floor(23));
      }, 41.66667);

      // Run logoGlitchTimeout
      setTimeout( this.unGlitchTheLogo, this.lengthOfGlitch );

    },

    //--- Function unGlitch The Logo ---//
    unGlitchTheLogo ( ) {

      // Stop the glitchInterval
      clearInterval(this.glitchMachine);

      // Change the logo back to regular logo
      this.position = 0;

      // Rerun initializeGlitchTimeout Function
      this.initializeGlitchTimeout();

    }

  },

  mounted() {

    this.initializeGlitchTimeout();

  }

};

</script>

<!-- CSS -->
<style lang="scss" scoped>

@import "../../assets/scss/variables.scss";

img {
  height: 50px;
}

</style>
